import { render, staticRenderFns } from "./gridOld.vue?vue&type=template&id=a394171a"
import script from "./gridOld.vue?vue&type=script&lang=js"
export * from "./gridOld.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports